import EmojiAvatar from "~/components/shared/EmojiAvatar";
import Icon from "~/components/shared/Icon";

import { Example } from "~/components/shared/Examples/useExamples";

export function ExampleSummary({ example }: { example: Example }) {
  return (
    <>
      <div className="flex items-center gap-2">
        <EmojiAvatar emoji={example.emoji} color={example.color} fallbackColor="var(--gray-100)" />
        <span className="truncate text-base font-semibold">{example.name}</span>
      </div>

      <div className="flex gap-3">
        <a
          href={example.repository_url}
          className="flex items-center text-purple-600 underline underline-offset-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Source on GitHub{" "}
          <Icon icon="heroicons/16/solid/arrow-up-right" className="block size-4" />
        </a>
        <a
          href={example.pipeline_url}
          className="flex items-center text-purple-600 underline underline-offset-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Demo pipeline <Icon icon="heroicons/16/solid/arrow-up-right" className="block size-4" />
        </a>
      </div>

      <div className="">{example.description}</div>
    </>
  );
}
